import { makeStyles, Tab, Tabs as MuiTabs } from "@material-ui/core"
import clsx from "clsx"
import React from "react"
import { colors } from "../../utils/theme"

interface TabPanelProps {
  children?: React.ReactNode
  index: number
  value: boolean
  className?: string
}

export const TabPanel: React.FC<TabPanelProps> = ({
  children,
  value,
  index,
  ...other
}) => {
  return (
    <div
      role="tabpanel"
      hidden={!value}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value && children}
    </div>
  )
}

export function a11yPropsForTabs(index: any) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  }
}

interface TabsProps<T extends string> {
  ariaLabel: string
  tabs: {
    className?: string
    label: T
  }[]
  tabPanelClass?: string
  tabsContainerClass?: string
  onChange?: (label: T) => void
  initialTab?: T
  enabled?: boolean
}

const useStyles = makeStyles((theme) => ({
  tabButton: {
    "&.Mui-focusVisible": {
      border: `2px solid ${colors.primary.periwinkle}`,
      //   borderColor: colors.primary.periwinkle,
    },
  },
}))

export const Tabs = <T extends string>({
  ariaLabel,
  tabs,
  children,
  tabPanelClass,
  tabsContainerClass,
  onChange,
  initialTab,
  enabled,
}: React.PropsWithChildren<TabsProps<T>>) => {
  const classes = useStyles()
  const [tab, setTab] = React.useState<T>(initialTab ?? tabs[0].label)
  const changeTab = (event: React.ChangeEvent<{}>, newValue: T) => {
    if (enabled === false) {
      return
    }
    setTab(newValue)
    onChange?.(newValue)
  }
  return (
    <>
      <MuiTabs
        value={tab}
        onChange={changeTab}
        aria-label={ariaLabel}
        variant="fullWidth"
        TabIndicatorProps={{ style: { display: "none" } }}
        className={tabsContainerClass}
      >
        {tabs.map((t, index) => (
          <Tab
            key={t.label}
            className={clsx(classes.tabButton, t.className)}
            label={t.label}
            value={t.label}
            disabled={enabled === false}
            {...a11yPropsForTabs(index)}
          />
        ))}
      </MuiTabs>
      {React.Children.map(children, (child, index) => (
        <TabPanel
          className={tabPanelClass}
          value={tab === tabs[index]?.label}
          index={index}
        >
          {child}
        </TabPanel>
      ))}
    </>
  )
}
